import { render, staticRenderFns } from "./MedicineReportKO.vue?vue&type=template&id=0a5f5565"
import script from "./MedicineReportKO.vue?vue&type=script&lang=js"
export * from "./MedicineReportKO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports